export const heroMedia = {
  home: { video: '/media/videos/home-hero.mp4', poster: '/media/images/cnc-5axis.jpg' },
  oilGas: { video: '/media/videos/oil-gas-hero.mp4', poster: '/media/images/oil-gas-hero-wellhead.jpg' },
  dataCenters: { video: '/media/videos/data-hall.mp4', poster: '/media/images/data-hall.jpg' },
  dataCenterConduit: { video: '/media/videos/dc-conduit-hero.mp4', poster: '/media/images/duct-bank-trench.jpg' },
  industrial: { video: '/media/videos/industrial-hero.mp4', poster: '/media/images/pump-housing-cnc.jpg' },
  ductBank: { video: '/media/videos/duct-bank-trench.mp4', poster: '/media/images/duct-bank-trench.jpg' },
};
